module.exports = __webpack_public_path__ + "img/zdd_invite_tx_3.4bdfd88a.png";